"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* istanbul ignore file */


var synchronizedState = {};

var createSynchronizedState = function createSynchronizedState(key, callback, initialState) {
  if (!synchronizedState[key]) {
    synchronizedState[key] = {
      callbacks: [],
      value: initialState
    };
  }

  synchronizedState[key].callbacks.push(callback);
  return {
    unregister: function unregister() {
      var callbacks = synchronizedState[key].callbacks;
      var index = callbacks.indexOf(callback);

      if (index > 1) {
        callbacks.splice(index, 1);
      }
    },
    emit: function emit(value) {
      if (!(0, _isEqual2["default"])(synchronizedState[key].value, value)) {
        synchronizedState[key].value = value;
        synchronizedState[key].callbacks.forEach(function (cb) {
          if (callback !== cb) {
            cb(value);
          }
        });
      }
    }
  };
};

var _default = createSynchronizedState;
exports["default"] = _default;